import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { clearPublisher } from '../Browse/publisherReducer';
import { clearPublishers } from '../Browse/publishersReducer';
import { clearNotifications } from '../../components/notifications/notificationsReducer';
import { logout } from '../auth/authReducer';
import { isInternalUser } from '../../helpers/authorization';
import { redirectToAuthPicker } from '../../helpers/auth';
import { useAppSelector } from '../../store';

type LogoutProps = {
    // /external-logout always lands the user back on the password form, even if they
    // arrived as an internal user; /logout branches on user type instead.
    external?: boolean;
};

/**
 * Deliberate logout. Internal (SSO) users go back to the applications picker rather than
 * the external password form, since that form is not a login path they have credentials
 * for. External publishers always land on the password form, which is correct for them.
 */
const Logout = ({ external = false }: LogoutProps) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // Read before dispatching logout() below clears it.
    const user = useAppSelector(state => state.auth);
    const goToPicker = !external && isInternalUser(user);

    useEffect(() => {
        dispatch(clearPublisher());
        dispatch(clearPublishers());
        dispatch(clearNotifications());
        dispatch(logout());

        if (goToPicker) {
            redirectToAuthPicker();
        } else {
            navigate('/login', { replace: true });
        }
    }, []);

    return null;
};

export default Logout;
